import { exportToExcel } from "../../../utils/helper";

function getValueByPath(obj, keyPath) {
  if (!obj || typeof obj !== "object") return undefined;
  if (!keyPath || typeof keyPath !== "string") return undefined;
  return keyPath.split(".").reduce((acc, key) => {
    if (acc == null || typeof acc !== "object") return undefined;
    return acc[key];
  }, obj);
}

function formatDateForBreakdownExport(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-US", { day: "2-digit", month: "short", year: "numeric" }).format(date);
}

function cellValueForBreakdownExport(col, row) {
  const raw = getValueByPath(row, col.key);
  if (col.type === "pill" && raw && typeof raw === "object") {
    return raw.label || "-";
  }
  if (col.type === "date") {
    return raw == null || raw === "" ? "-" : formatDateForBreakdownExport(raw);
  }
  return raw == null || raw === "" ? "-" : String(raw);
}

export function exportBreakdownRows({ rows, columns, fileName }) {
  if (!Array.isArray(rows) || !rows.length || !Array.isArray(columns) || !columns.length) return;
  const exportColumns = columns.reduce((acc, col) => {
    const header = (col.label || col.key || "").toUpperCase();
    acc[header] = (row) => cellValueForBreakdownExport(col, row);
    return acc;
  }, {});
  exportToExcel({ data: rows, fileName: fileName || "breakdown_export", sheetName: "Data", columns: exportColumns });
}
